import PLPSEO from './PlpSeo.component';

export default PLPSEO;